/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { ClaimAccountResponse, ClaimAccountVars } from '../openapi-types.gen.js';

export type { ClaimAccountResponse, ClaimAccountVars } from '../openapi-types.gen.js';

export const useClaimAccount = createMutationHook<ClaimAccountVars, ClaimAccountResponse, unknown>({
  specName: 'useClaimAccount',
  path: '/v1/rewards/account/claim',
  method: 'POST',
  resolveUrl: (vars: ClaimAccountVars) => `/v1/rewards/account/claim`,
  
  parseResponse: (raw: unknown): ClaimAccountResponse => raw as ClaimAccountResponse,
  
  
  
});
